import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './App.css';
import Login from './pages/Login';
import TemplateEditor from './pages/TemplateEditor';
import SendInterface from './pages/SendInterface';

const API_BASE_URL = '/api';

export default function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [currentPage, setCurrentPage] = useState('send');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/auth/status`, {
        withCredentials: true,
      });
      setAuthenticated(res.data.authenticated);
    } catch (error) {
      setAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await axios.post(`${API_BASE_URL}/auth/logout`, {}, {
        withCredentials: true,
      });
      setAuthenticated(false);
      setCurrentPage('send');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  if (loading) {
    return (
      <div className="app loading">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!authenticated) {
    return <Login onLoginSuccess={() => {
      setAuthenticated(true);
      checkAuthStatus();
    }} />;
  }

  return (
    <div className="app authenticated">
      <header className="app-header">
        <div className="logo">
          <h1>📱 TelegramPost</h1>
          <p>Web Interface</p>
        </div>
        
        <nav className="nav-menu">
          <button
            className={`nav-btn ${currentPage === 'send' ? 'active' : ''}`}
            onClick={() => setCurrentPage('send')}
          >
            ✈ Send
          </button>
          <button
            className={`nav-btn ${currentPage === 'editor' ? 'active' : ''}`}
            onClick={() => setCurrentPage('editor')}
          >
            ✎ Edit Templates
          </button>
        </nav>

        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </header>

      <main className="app-content">
        {currentPage === 'send' && <SendInterface apiBase={API_BASE_URL} />}
        {currentPage === 'editor' && (
          <TemplateEditor
            apiBase={API_BASE_URL}
            onCancel={() => setCurrentPage('send')}
          />
        )}
      </main>
    </div>
  );
}
